import { SelectItem } from "../../../../../../../utils/utils";
import { ORDER_STATUS_OPTIONS } from "../../../../scheduling/appointment/encounter/default-forms/UpsertLabRequisitionForm";

export const PrescriptionFormInitialValues = {
  prescriptionFormType: undefined,
  medication: undefined,
  medicationId: undefined,
  prescriptionDate: new Date(),
  provider: undefined,
  location: undefined,
  patient: undefined,
  directionToPatient: undefined,
  duration: undefined,
  quantity: undefined,
  unit: undefined,
  refills: undefined,
  startDate: undefined,
  endDate: undefined,
  substitutionsOrDispense: undefined,
  preferences: undefined,
  notFillBefore: undefined,
  preferredDelivery: undefined,
  priorAuthorization: undefined,
  directionToPharmacist: undefined,
  medicalCodes: undefined,
  active: undefined,
  archive: undefined,
  appointmentId: undefined,
  providerStatus: undefined,
};

export const PRESCRIPTION_MAPPER: Record<string, string> = {
  NEW_RX: "New",
  CHANGE_RX: " Change",
  REFILE: "Refill",
};

// Mapper function to get status options based on current order status
// Superseded by getOrderActionOptions below, which returns the complete Actions
// menu (not only the status transitions) for a Labs/Imaging order.
// export const getStatusOptions = (currentStatus: string) => {
//   switch (currentStatus) {
//     case ORDER_STATUS_OPTIONS.DRAFT:
//       return [
//         {
//           value: ORDER_STATUS_OPTIONS.PRINTED,
//           label: "Mark as Printed",
//         },
//         {
//           value: ORDER_STATUS_OPTIONS.CANCELLED,
//           label: "Cancel Order",
//         },
//       ];
//     case ORDER_STATUS_OPTIONS.PRINTED:
//       return [
//         {
//           value: ORDER_STATUS_OPTIONS.RESULT_PENDING,
//           label: "Mark as Result Pending",
//         },
//         {
//           value: ORDER_STATUS_OPTIONS.CANCELLED,
//           label: "Cancel Order",
//         },
//       ];
//     case ORDER_STATUS_OPTIONS.RESULT_PENDING:
//       return [
//         {
//           value: ORDER_STATUS_OPTIONS.COMPLETED,
//           label: "Mark as Completed",
//         },
//         {
//           value: ORDER_STATUS_OPTIONS.CANCELLED,
//           label: "Cancel Order",
//         },
//       ];
//     case ORDER_STATUS_OPTIONS.COMPLETED:
//     case ORDER_STATUS_OPTIONS.CANCELLED:
//       return [];
//     default:
//       return [];
//   }
// };

const EDIT_ORDER_ACTION: SelectItem = { value: "edit", label: "Edit" };

const ADD_RESULT_ACTION: SelectItem = {
  value: "addResult",
  label: "Add Result",
};

// Opens the result document(s) attached to a completed order.
export const VIEW_ORDER_REPORT_ACTION: SelectItem = {
  value: "view",
  label: "View & Download Report",
};

// Opens the Order Print (requisition) of an already placed order.
const VIEW_ORDER_ACTION: SelectItem = {
  value: "viewOrder",
  label: "View Order",
};

// The status transitions carry the target status as their value — the Actions
// handler feeds it straight into the change-status confirmation.
const MARK_ORDER_COMPLETED_ACTION: SelectItem = {
  value: ORDER_STATUS_OPTIONS.COMPLETED,
  label: "Mark as Completed",
};

const CANCEL_ORDER_ACTION: SelectItem = {
  value: ORDER_STATUS_OPTIONS.CANCELLED,
  label: "Cancel Order",
};

/**
 * @description
 * Actions available on a Labs/Imaging order, driven entirely by its status:
 *
 * - Draft      → Edit, Cancel Order
 * - Pending    → Edit, Mark as Completed, Add Result, Cancel Order
 * - Ordered    → View Order (Order Print)
 * - Completed  → View & Download Report
 * - Canceled   → none
 *
 * "Mark as Printed" is intentionally absent: the Printed status was dropped from
 * the order flow, so no new order can reach it and legacy Printed orders are
 * left without actions.
 */
export const getOrderActionOptions = (orderStatus?: string): SelectItem[] => {
  switch (orderStatus) {
    case ORDER_STATUS_OPTIONS.DRAFT:
      return [EDIT_ORDER_ACTION, CANCEL_ORDER_ACTION];
    case ORDER_STATUS_OPTIONS.RESULT_PENDING:
      return [
        EDIT_ORDER_ACTION,
        MARK_ORDER_COMPLETED_ACTION,
        ADD_RESULT_ACTION,
        CANCEL_ORDER_ACTION,
      ];
    case ORDER_STATUS_OPTIONS.ORDERED:
      return [VIEW_ORDER_ACTION];
    case ORDER_STATUS_OPTIONS.COMPLETED:
      return [VIEW_ORDER_REPORT_ACTION];
    case ORDER_STATUS_OPTIONS.CANCELLED:
      return [];
    default:
      return [];
  }
};
